import React, { useReducer } from 'react';
import styled from 'styled-components';

import ArrowDown from '../../svgs/ArrowDown';
import SavedTag from '../common/SavedTag';
import SimpleLoadingSpinner from '../SimpleLoadingSpinner';

type Props = {
  title: string;
  children: React.ReactNode;
  id?: string;
  defaultOpen?: boolean;
  isSaving?: boolean;
  isSaved?: boolean;
};

const Accordion = (props: Props) => {
  const { title, children, isSaving, isSaved, id, defaultOpen = true } = props;
  const [isOpen, toggleAccordion] = useReducer(state => !state, defaultOpen);

  return (
    <Container id={id}>
      <AccordionButton onClick={toggleAccordion} isOpen={isOpen}>
        <h2>{title}</h2>
        {isSaving && !isSaved && (
          <SimpleLoadingSpinner
            text={null}
            icon={null}
            spinnerSize={16}
            spinnerWidth={3}
          />
        )}
        {isSaved !== undefined && <SavedTag isSaved={isSaved} />}
        <ArrowDown width="12" strokeColor="var(--accent)" />
      </AccordionButton>
      {isOpen && <AccordionContent>{children}</AccordionContent>}
    </Container>
  );
};

const Container = styled.div``;

const AccordionButton = styled.div<{ isOpen: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  margin: 0 -10px;
  border-radius: 4px;
  user-select: none;
  transition: var(--transition-normal);
  gap: 16px;
  &:hover {
    background-color: var(--surface-elevated);
  }
  > h2 {
    color: var(--foreground);
    font-size: 20px;
    font-weight: var(--font-weight-bold);
    margin: 0;
  }
  > svg {
    color: var(--accent);
    transition: var(--transition-normal);
    transform: ${({ isOpen }) => (isOpen ? 'rotate(-180deg)' : 'rotate(0deg)')};
    margin-left: auto;
  }
`;

const AccordionContent = styled.div`
  margin-top: 24px;
`;

export default Accordion;
